/**
 * Конфигурация API
 * Поддержка нескольких окружений (DEV, PROD)
 */

// Окружения по умолчанию
const DEFAULT_ENV = 'dev';

// Конфигурации для разных окружений
const ENVIRONMENTS = {
  dev: {
    baseUrl: 'http://dotcher/snreg/api/',
    debug: true
  },
  prod: {
    baseUrl: '/snreg/api/',
    debug: false
  }
};

/**
 * Текущее окружение
 */
let currentEnv = DEFAULT_ENV;

/**
 * Устанавливает текущее окружение
 * @param {string} env - Окружение ('dev' или 'prod')
 */
export function setEnvironment(env) {
  if (ENVIRONMENTS[env]) {
    currentEnv = env;
  } else {
    console.warn(`Unknown environment: ${env}, using default: ${DEFAULT_ENV}`);
  }
}

/**
 * Получает текущее окружение
 * @returns {string} Текущее окружение
 */
export function getEnvironment() {
  return currentEnv;
}

/**
 * Определяет базовый путь из текущего URL (для автоопределения)
 * @returns {string} Базовый путь (например, '/snreg' или '')
 */
function getBasePathFromUrl() {
  const segments = window.location.pathname.split('/').filter(Boolean);
  return segments.length > 0 ? `/${segments[0]}` : '';
}

/**
 * Получает полный базовый URL для API в зависимости от окружения
 * @returns {string} Полный базовый URL для API
 */
export function getBaseUrl() {
  const envConfig = ENVIRONMENTS[currentEnv];

  // Если baseUrl содержит 'http://' или 'https://', используем как есть (полный URL)
  if (envConfig.baseUrl.includes('http://') || envConfig.baseUrl.includes('https://')) {
    return envConfig.baseUrl;
  }

  // Для относительных путей просто возвращаем baseUrl (он уже содержит trailing slash)
  return envConfig.baseUrl;
}

/**
 * Путь к API относительно base path (для внутреннего использования)
 */
export const API_PATH = '/api/';

/**
 * Получает полный путь к endpoint
 * @param {string} endpoint - Endpoint (например, 'login')
 * @returns {string} Полный URL для запроса
 */
export function getEndpointUrl(endpoint) {
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.substring(1) : endpoint;
  return `${getBaseUrl()}${cleanEndpoint}`;
}

/**
 * Экспорт конфигурации
 */
export default {
  ENVIRONMENTS,
  DEFAULT_ENV,
  setEnvironment,
  getEnvironment,
  getBaseUrl,
  getEndpointUrl,
  API_PATH
};
